import React, { useState } from 'react';
import {
  CURRENT_RATES,
  PROTOCOL_CONSTANTS
} from '../constants/pricing';

const StakingModalV2 = ({ isOpen, onClose, userICP = 0, balances = {} }) => {
  const [stakeAmount, setStakeAmount] = useState('');

  if (!isOpen) return null;

  const icpStakeAmount = parseFloat(stakeAmount) || 0;
  const nIcpReceived = icpStakeAmount * CURRENT_RATES.icpToNICP_staking;
  const wtnAirdrop = (icpStakeAmount / 100) * PROTOCOL_CONSTANTS.WTN_PER_100_ICP;
  const hasInsufficientFunds = icpStakeAmount > userICP;
  
  // Market comparison calculations
  const nIcpFromMarket = icpStakeAmount * CURRENT_RATES.icpToNICP_market; // nICP received from market swap
  const marketAdvantage = nIcpFromMarket - nIcpReceived; // Extra nICP from market vs staking
  const delayedUnstakeValue = nIcpFromMarket * PROTOCOL_CONSTANTS.N_ICP_NAV_OVER_ICP_PROTOCOL; // Protocol redemption rate
  const totalGainFromMarketStrategy = delayedUnstakeValue - icpStakeAmount; // Total ICP gain
  const apyFromMarketStrategy = (totalGainFromMarketStrategy / icpStakeAmount) * 2 * 100; // Annualized APY (~6 months = 0.5 years)
  
  const handleMaxStake = () => {
    setStakeAmount(userICP.toString());
  };

  const handleStake = () => {
    if (icpStakeAmount <= 0 || icpStakeAmount > userICP) return;
    // TODO: Implement staking logic
    console.log('Staking:', icpStakeAmount, 'ICP');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="staking-modal-v2" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Stake ICP</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Amount Input */}
          <div className="amount-input-container">
            <input
              type="number"
              value={stakeAmount}
              onChange={(e) => setStakeAmount(e.target.value)}
              placeholder="0.00"
              className="amount-input"
            />
            <div className="input-controls">
              <button 
                className="max-button"
                onClick={handleMaxStake}
              >
                MAX
              </button>
              <div className="token-info">
                <span className="token-symbol">ICP</span>
                <div className="token-icon">∞</div>
              </div>
            </div>
          </div>

          {/* You will receive */}
          <div className="receive-info">
            <span className="receive-text">You will receive {nIcpReceived.toFixed(2)} nICP</span>
          </div>

          {/* Exchange Rate - simplified */}
          <div className="exchange-rate-simple">
            <span className="rate-icon">⚡</span>
            <span className="rate-text">1 ICP = {CURRENT_RATES.icpToNICP_staking.toFixed(8)} nICP</span>
            <span className="rate-trend">📈</span>
          </div>

          {/* Future WTN Airdrop - simplified */}
          <div className="airdrop-info-simple">
            <span className="airdrop-text">Future WTN Airdrop: {wtnAirdrop > 0 ? `${wtnAirdrop.toFixed(2)} WTN` : '-/-'}</span>
            <span className="airdrop-icon">🌹</span>
          </div>

          {/* Error Message */}
          {hasInsufficientFunds && (
            <div className="error-message">
              Insufficient funds. Available: {userICP.toFixed(2)} ICP
            </div>
          )}

          {/* Market Opportunity Hint */}
          {icpStakeAmount > 0 && marketAdvantage > 0 && (
            <div className="market-hint-banner">
              <div className="hint-content">
                <p className="hint-main">
                  <span className="hint-icon">💡</span>
                  nICP is currently priced below direct staking. <b>A market swap would return about +{marketAdvantage.toFixed(2)} nICP more </b> compared to staking. If redeemed after 6 months, this equals roughly +{totalGainFromMarketStrategy.toFixed(2)} ICP (~{apyFromMarketStrategy.toFixed(1)}% APY).
                </p>
                <button
                  className="dex-swap-button"
                  onClick={onClose}
                >
                  Close, I'll swap to nICP
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button 
            className="action-button secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="action-button primary"
            onClick={handleStake}
            disabled={icpStakeAmount <= 0 || hasInsufficientFunds}
          >
            Stake
          </button>
        </div>
      </div>
    </div>
  );
};

export default StakingModalV2;
